import { Link } from "react-router-dom";
import type { Actor } from "@/mocks/actors";
import FavoriteButton from "@/components/base/FavoriteButton";
import { useFavorites } from "@/hooks/useFavorites";

interface ActorCardProps {
  actor: Actor;
}

export default function ActorCard({ actor }: ActorCardProps) {
  const { isActorFavorite, toggleActor } = useFavorites();

  return (
    <div className="group relative">
      <Link
        to={`/detail/actor/${actor.id}`}
        className="block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
      >
        <div className="relative w-full aspect-square overflow-hidden bg-background-200">
          <img
            src={actor.avatar}
            alt={`${actor.name}头像`}
            title={`${actor.name} - 葵司演员资料`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute bottom-2 left-2 px-2 py-0.5 rounded-md bg-background-950/70 text-background-50 text-xs">
            {actor.gender} · {actor.region}
          </span>
        </div>
        <div className="p-3">
          <h3 className="font-heading font-bold text-foreground-950 text-base truncate">
            {actor.name}
          </h3>
          <p className="mt-1 text-xs text-foreground-600 line-clamp-1">
            代表作品：{actor.representative}
          </p>
          <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
            {actor.bio}
          </p>
        </div>
      </Link>
      <FavoriteButton
        active={isActorFavorite(actor.id)}
        onToggle={() => toggleActor(actor.id)}
        className="absolute top-2 right-2"
      />
    </div>
  );
}